"use client"
import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"

const UserManagementDashboard: React.FC = () => {
  const navigate = useNavigate()
  
  useEffect(() => {
    // Redirect to the enhanced admin dashboard
    navigate('/enhanced-admin-dashboard')
  }, [navigate])
  
  // Show a loading message while redirecting
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div>Loading enhanced dashboard...</div>
    </div>
  )
}

export default UserManagementDashboard